export const getValueOfCssVariable = (
  variable: string,
  element = document.body,
) => {
  const property = variable.replace(/var\(|\)/g, '');

  const propertyValue = getComputedStyle(element)
    .getPropertyValue(property)
    .trim();

  return propertyValue ? propertyValue : null;
};
